
// Backgammon
// ?did=" + BgManager.M.deviceModel.deviceId +
// "&uid=" + BgManager.M.playerModel.user_id.toString() +
// "&plm=" + BgManager.M.deviceModel.getPlatformId() +
// "&lae=" + BgManager.C.textMapController.lang +
// "&s=" + subjectsMapTypes[_type] +
// "&v=" + BgManager.M.lobbyModel.supportUrlVersion

// Spades & Rummy
// ?did=&uid={1}&email={2}&plt={3}&lang={4}&name={5}&subject={6}&message={7}


class QueryStringFactory {

    constructor() {
        this.queryStringMap = new Map();
        this.queryStringMap.set('name', 'fName');
        this.queryStringMap.set('plm', 'plt');
        this.queryStringMap.set('lae', 'lang');
        this.queryStringMap.set('s', 'subject');
    }

    create(initState, query) {
        const state = Object.assign({}, initState);
        new URLSearchParams(query).forEach((data, key) => {
            if (this.queryStringMap.has(key)) key = this.queryStringMap.get(key);
            if (key in state) state[key] = data;
        });
        return state;
    }
}

export default QueryStringFactory;